import axios from 'axios';
import { getAuthHeaders } from './userController';

const BASE_URL = 'https://autoseguro.api.ikeytechnologies.com/asistencias-por-sucursal/';

export const fetchAsistenciasPorSucursal = async (sucursalId, fechaInicio, fechaFin) => {
  try {
    const payload = {
      sucursal_id: sucursalId,
      fecha_inicio: fechaInicio,  // Formato ISO 8601, ej: '2025-05-16T00:00:00Z'
      fecha_fin: fechaFin,
    };

    const response = await axios.post(BASE_URL, payload, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener asistencias por sucursal:', error);
    throw error;
  }
};
